export enum GemCut {
  Cabochon = 'Cabochon',
  Faceted = 'Faceted',
  BrilliantStep = 'Brilliant Step',
  Brilliant = 'Brilliant',
  BrilliantFancy = 'Brilliant Fancy',
  ModifiedBrilliant = 'Modified Brilliant',
  ModifiedBrilliantFancy = 'Modified Brilliant Fancy',
  Fancy = 'Fancy',
  ModifiedBrilliantStep = 'Modified Brilliant Step',
  Bufftop = 'Bufftop',
  Princess = 'Princess',
  Radiant = 'Radiant',
  Step = 'Step',
  Fantasy = 'Fantasy',
  Intaglio = 'Intaglio',
  Rose = 'Rose',
  Carved = 'Carved',
  Cameo = 'Cameo',
  Checkerboard = 'Checkerboard',
  SugarLoafCabochon = 'Sugar Loaf Cabochon',
  Other = 'Other',
}
